export const getCompanyId = () => {
  try {
    const dataCompanyString = localStorage.getItem('dataCompany');

    if (!dataCompanyString) {
      return null;
    }

    const dataCompany = JSON.parse(dataCompanyString);

    if (!dataCompany || typeof dataCompany !== 'object') {
      return null;
    }

    return dataCompany.companyId || null;
  } catch (error) {
    console.error('Error conultando companyId del localStorage:', error);
    return null;
  }
};
